import { render, staticRenderFns } from "./HoldingView.vue?vue&type=template&id=4241f2ae&scoped=true"
import script from "./HoldingView.vue?vue&type=script&lang=js"
export * from "./HoldingView.vue?vue&type=script&lang=js"
import style0 from "./HoldingView.vue?vue&type=style&index=0&id=4241f2ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4241f2ae",
  null
  
)

export default component.exports